import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import { ModalManagementButtons } from '../ModalManagementButtons';
import { useFormik } from 'formik';
import {
  COMMENT_FORM_FIELD, commentDetailsSchema,
  commentInitialValues, internalCommentValidationSchema,
} from '../../constants/comment/comment-form';
import { FormInput } from '../merchants/FormInput';
import { formInputFieldName, InputType } from '../form/form-input-constants';
import { usePaymentContext } from '../../store/payments/payments-context';
import { fetchUnpostedBatchData } from '../../store/payments/actions/batches';
import { useLocation } from 'react-router';
import { IBatchesFiltersParams } from './BatchesFilterSection';
import { parseSearchParams } from '../../utils/utilities';

interface Props {
  fieldName: formInputFieldName;
  label: string;
  placeholder?: string;
  value?: string;
  additionalClass?: string;
  additionalContentClass?: string;
  closeModal?: () => void;
  payoutId?: string;
  saveComment?: (payoutId: string, comment: string) => Promise<void>;
}
export const CommentModal:FC<Props> = (props) => {
  const {
    fieldName, label, value, placeholder,
    payoutId, closeModal, saveComment,
    additionalClass, additionalContentClass
  } = props;

  const { search } = useLocation();

  const { dispatch } = usePaymentContext();
  const [loading, setLoading] = useState<boolean>(false);

  const filtersFromUrl: IBatchesFiltersParams = parseSearchParams(search) || {};

  const formik = useFormik({
    initialValues: commentInitialValues,
    validationSchema: fieldName === COMMENT_FORM_FIELD.COMMENT
      ? commentDetailsSchema
      : internalCommentValidationSchema,
    // validationSchema: commentDetailsValidationSchema,
    onSubmit: () => void 0,
  });

  useEffect(() => {
    formik.setFieldValue(fieldName, value ?? '');
  }, []);


  const handleSubmit = async (): Promise<void> => {
    formik.handleSubmit();
    if (!formik.isValid) return;
    try {
      setLoading(true);
      await saveComment(payoutId, formik.values[fieldName]);

      setLoading(false);
      closeModal();

      await fetchUnpostedBatchData({ dispatch, params: filtersFromUrl });

    } catch (e) {
      closeModal();
      setLoading(false);
      console.log('handleSubmit error', e);
    }
  };

  return (
    <div className={clsx(additionalContentClass)}>
      <FormInput
        formik={formik}
        fieldName={fieldName}
        label={label}
        placeholder={placeholder}
        inputType={InputType.Description}
        isEditMode={true}
        additionalClasses={additionalClass}
      />

      <ModalManagementButtons
        onCancel={closeModal}
        containerAdditionalClasses="mt-10"
        confirmBtnName="Save"
        onConfirm={handleSubmit}
        isConfirmBtnLoading={loading}
      />

    </div>
  );
};
